module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/banner-aai-large-7397d336310487410eb2ac9ab39efaf9.png";